import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    isAuthenticated: localStorage.getItem('user'),
    layout: null,
    snackbar: {
      color: '',
      message: '',
      status: false,
      timeout: 2500
    },
    user: null,
    usersTab: 'tab-active'
  },

  mutations: {
    CLEAR_USER_DATA (state) {
      localStorage.removeItem('user')
      location.reload()
    },

    SET_LAYOUT (state, payload) {
      state.layout = payload
    },

    SET_SNACKBAR (state, payload) {
      state.snackbar = payload
    },

    SET_USER_DATA (state, payload) {
      state.user = payload
      localStorage.setItem('user', JSON.stringify(payload))
      axios.defaults.headers.common.Authorization = `Bearer ${payload.token}`
    },

    SET_USERS_TAB (state, payload) {
      state.usersTab = payload
    }
  },

  getters: {
    isAdmin: state => !!state.user && state.user.user.role === 'admin',
    isAuthenticated: state => !!state.isAuthenticated || !!state.user,
    layout: state => state.layout,
    snackbar: state => state.snackbar,
    user: state => state.user.user,
    usersTab: state => state.usersTab
  },

  actions: {
    // Auth
    login ({ commit }, credentials) {
      return axios.post('/login', credentials)
        .then(({ data }) => {
          commit('SET_USER_DATA', data)

          return data.user
        })
        .catch((error) => {
          commit('SET_SNACKBAR', {
            color: 'pink',
            message: error.response.data.message[0],
            timeout: 3000,
            status: true
          })
          throw error
        })
    },

    logout ({ commit }) {
      return axios
        .post('/logout')
        .then(({ data }) => {
          commit('CLEAR_USER_DATA')
        })
    },

    register ({ commit, getters }, credentials) {
      return axios.post('/register', credentials)
        .then(({ data }) => {
          if (!getters.isAdmin) {
            commit('SET_USER_DATA', data)
          }

          return data.user
        })
        .catch((error) => {
          throw error
        })
    },

    resetPassword ({ commit }, credentials) {
      return axios.post('/password/reset', credentials)
        .then(({ data }) => {
          commit('SET_USER_DATA', data)

          commit('SET_SNACKBAR', {
            color: 'cyan darken-1',
            message: 'Your password has been reset successfully!',
            timeout: 3000,
            status: true
          })

          return data.user
        })
        .catch((error) => {
          commit('SET_SNACKBAR', {
            color: 'pink',
            message: 'Oops! Something went wrong.',
            timeout: 3000,
            status: true
          })
          throw error
        })
    },

    sendResetPasswordLink ({ commit }, credentials) {
      return axios.post('/password/email', credentials)
        .then(({ data }) => {
          commit('SET_SNACKBAR', {
            color: 'cyan darken-1',
            message: 'A fresh verification link has been sent to your email address. Please check your email for a verification link.',
            timeout: 5000,
            status: true
          })
          return data
        })
        .catch((error) => {
          commit('SET_SNACKBAR', {
            color: 'pink',
            message: 'Oops! Invalid email, User not found',
            timeout: 3000,
            status: true
          })
          throw error
        })
    }
  }
})
